import { inject, Provider } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BdAppEnvironmentService } from '@bindoc-projects/platform-lib/data';
import {
  CacheService,
  provideResourceRegistrations,
} from '@bindoc-projects/resource-lib/data';
import { ApiEndpointKeyType } from '@bindoc-projects/app-config-domain-lib';
import { ShareableType } from '@bindoc-projects/resource-domain-lib';
import {
  BdAdministrativeDistrictService,
  BdPostalCodeService,
} from '@bindoc-projects/geographic-lib/data';
import { AysVirtualClinicAnalysisService } from './virtual-clinic-analysis.service';
import { AysVirtualClinicAnalysisGroupByService } from './virtual-clinic-analysis-group-by.service';
import { VirtualClinicService } from './virtual-clinic.service';

export interface VirtualClinicDataOptions {
  endpoint: ApiEndpointKeyType;
  resourceNames: ShareableType[];
  /** Import apps only select/upload resources; they do not resolve analysis or geography. */
  resolveAnalysis: boolean;
}

export function provideVirtualClinicData(
  options: VirtualClinicDataOptions,
): Provider[] {
  return [
    {
      provide: VirtualClinicService,
      useFactory: () =>
        new VirtualClinicService(
          { API_TOKENS: { BASE: options.endpoint } },
          inject(BdAppEnvironmentService),
          inject(CacheService),
          inject(HttpClient),
          options.resolveAnalysis
            ? inject(AysVirtualClinicAnalysisService)
            : null,
          options.resolveAnalysis ? inject(BdPostalCodeService) : null,
          options.resolveAnalysis
            ? inject(BdAdministrativeDistrictService)
            : null,
        ),
    },
    ...provideResourceRegistrations(
      VirtualClinicService,
      ...options.resourceNames,
    ),
  ];
}

export function provideVirtualClinicAnalysisData(
  endpoint: ApiEndpointKeyType,
): Provider[] {
  return [
    {
      provide: AysVirtualClinicAnalysisService,
      useFactory: () =>
        new AysVirtualClinicAnalysisService(
          { API_TOKENS: { BASE: endpoint } },
          inject(BdAppEnvironmentService),
          inject(CacheService),
          inject(HttpClient),
        ),
    },
    {
      provide: AysVirtualClinicAnalysisGroupByService,
      useFactory: () =>
        new AysVirtualClinicAnalysisGroupByService(
          { API_TOKENS: { BASE: endpoint } },
          inject(BdAppEnvironmentService),
          inject(CacheService),
          inject(HttpClient),
        ),
    },
  ];
}
